<div class="card" *blockUI="'section-block'">
  <div class="row mt-1 mb-1">
    <!-- Yeni Ürün Ekle Button -->
    <div class="row col-xl-6 col-md-12 col-sm-12 ml-1">
      <a href="#/admin/create-product" *ngIf="authService.isEndpointStatus('POST.Writing.CreateProduct')">
        <button class="btn btn-primary" rippleEffect>
          <i data-feather="plus" class="d-sm-none d-inline-block"></i>
          <span class="d-none d-sm-inline-block">Yeni Ürün Ekle</span>
        </button>
      </a>

      <div class="col-12 col-xl-1 col-md-6 col-sm-12">
        <button type="button" class="btn btn-icon btn-outline-primary" (click)="toggleFilterPanel()" rippleEffect>
          <span [data-feather]="'filter'"></span>
        </button>
      </div>
    </div>

    <div class="row col-xl-6 col-md-6 col-sm-12 justify-content-end mr-1">
      <div class="col-xl-6 col-md-6 col-sm-12">
        <label class="d-flex align-items-center">
          <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
            (search)="filterUpdate($event)" />
        </label>
      </div>

      <!-- Three Dots Button (Dropdown) -->
      <div ngbDropdown [placement]="'left'" class="btn-group dropup dropdown-icon-wrapper">
        <button ngbDropdownToggle type="button" class="btn btn-icon btn-flat-primary dropdown-toggle-split"
          rippleEffect>
          <span [data-feather]="'more-vertical'" class="'dropdown-icon'"></span>
        </button>
        <div ngbDropdownMenu>
          <span ngbDropdownItem (click)="exportAsExcelFile()">Excel'e Aktar</span>
          <span ngbDropdownItem (click)="priceElevation()">Alış Fiyatını Göster</span>
        </div>
      </div>

      <!-- Page Size Selector -->
      <label>
        <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="50">50</option>
        </select>
      </label>
    </div>


  </div>

  <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
    emptyMessage: 'Veri Yok',
    totalMessage: 'Toplam', 
    selectedMessage: 'Seçili'
  }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true"
    (activate)="onActivate($event)">
    <ng-template ngx-datatable-cell-template let-row="row">
      <a href="#/admin/detail-product/{{row.id}}">{{row.name}}</a>
    </ng-template>

    <ngx-datatable-column name="Ürün Adı" prop="name" [width]="400"></ngx-datatable-column>

    <ngx-datatable-column name="Alış Fiyatı" *ngIf="!isPrice" [width]="50">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{(row.purchasePrice | number:'1.2-2') ?? 0}} {{row.currencyName ?? ''}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Satış Fiyatı" [width]="100">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{(row.salePrice | number:'1.2-2') ?? 0}} {{row.currencyName ?? ''}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Kategori" [width]="150">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{row.categoryName ?? "Yok"}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Marka-Model" [width]="100">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{row.brandName ?? "Yok"}} {{row.brandModelName}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Etiketler" [width]="100">
      <ng-template ngx-datatable-cell-template let-row="row">
        <mat-chip-list *ngIf="row.labels && row.labels.length > 0">
          <div class="badge badge-pill badge-light-info">
            {{ row.labels[0].labelName }}
            {{getFormattedLength(row.labels)}}
          </div>
        </mat-chip-list>
        <span *ngIf="!row.labels || row.labels.length === 0">Yok</span>
      </ng-template>
    </ngx-datatable-column>


    <!-- <ngx-datatable-column [width]="40" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div ngbDropdown container="body">
                <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                  <span [data-feather]="'more-vertical'" [class]="'cursor-pointer'"></span>
                </button>
                <div ngbDropdownMenu>
                  <a href="#/admin/company/{{row.id}}" ngbDropdownItem
                    class="d-flex align-items-center"><i data-feather="file-text" class="mr-50"></i>Görüntüle</a>
                   <a href="javascript:;" ngbDropdownItem
                      ><span [data-feather]="'trash'" [size]="16" [class]="'mr-50'"></span> Delete</a
                    > 
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column> -->
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="datatable-footer-inner">
          <div class="page-count">
            Toplam Veri {{ totalCount }}
          </div>
          <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
            (pageChange)="onPageChange($event)" [maxSize]="5">
            <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                [class]="'font-weight-bolder'"></span>
            </ng-template>
            <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                [class]="'font-weight-bolder'"></span></ng-template>
          </ngb-pagination>
        </div>

      </ng-template>

    </ngx-datatable-footer>
  </ngx-datatable>
</div>


<div class="filter-panel" [class.open]="isFilterPanelOpen">
  <div class="filter-panel-header">
    <h5>Filtreler</h5>
    <button class="btn btn-close" (click)="toggleFilterPanel()">x</button>
  </div>

  <div class="filter-panel-body">
    <div class="form-group">
      <label>Marka</label>
      <ng-select [items]="brands" name="selectedBrand" bindLabel="brandName" bindValue="id" [(ngModel)]="brandId"
        [clearable]="false"></ng-select>
    </div>

    <div class="form-group">
      <label>Model</label>

      <ng-select [searchFn]="searchFn" name="selectedBrandModel" [items]="brandsModel" bindLabel="name" bindValue="id"
        groupBy="brandName" [(ngModel)]="brandModelId" [clearable]="false">
        <ng-template ng-optgroup-tmp let-item="item">
          {{ item.brandName || 'Unnamed group' }}
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <label>Birim</label>
      <ng-select name="selectedUnitType" [items]="unitTypes" bindValue="id" bindLabel="unitTypeName"
        (change)="filterUnitType($event)" [(ngModel)]="unitTypeId" [clearable]="false"></ng-select>
    </div>

    <div class="form-group">
      <label>Para Birimi</label>
      <ng-select [items]="currencies" name="selectedCurrency" bindLabel="currencyName" bindValue="id"
        [(ngModel)]="currencyId" [clearable]="false"></ng-select>
    </div>

    <div class="form-group">
      <label>Kategori</label>
      <ng-select [items]="categories" name="selectedCategory" bindValue="id" bindLabel="categoryName"
        (change)="filterCategory($event)" [(ngModel)]="categoryId" [clearable]="false">
      </ng-select>
    </div>

    <div class="form-group">
      <label>Depo</label>
      <ng-select [items]="warehouses" name="selectedWarehouse" bindValue="id" bindLabel="warehouseName"
        (change)="filterWarehouse($event)" [(ngModel)]="warehouseId" [clearable]="false">
      </ng-select>
    </div>

    <button class="btn btn-primary mr-1 mt-1" (click)="applyFilters()">Filtrele</button>
    <button class="btn btn-danger mt-1" (click)="clearFilters()">Temizle</button>
  </div>
</div>